import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({ providedIn: 'root' })
export class GenericPrintService extends BaseApiTemplateService<any>{
  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
  }

  private toEndpointPath(serverDocType: string): string {
    if (!serverDocType) {
      throw new Error('serverDocType is required');
    }
    const base = serverDocType
      .toLowerCase()
      .replace(/_/g, '-');

    // avoid double "s"
    return base.endsWith('s') ? base : base + 's';
  }

  printJasperPdf(
    serverDocType: string,
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string
  ): Observable<Blob> {
    const endpointPath = this.toEndpointPath(serverDocType);

    let params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid);

    if (customParam) {
      params = params.set('customParam', customParam);
    }

    const url =
      `${apiVisa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}` +
      `${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}${endpointPath}` +
      `/print-jasper-pdf/${guid}`;

    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}